// extracted by mini-css-extract-plugin
export default {"content":"No-page-found_content__zguyU","text":"No-page-found_text__Y2hxH","button":"No-page-found_button__YMlhJ","anim":"No-page-found_anim__Rjg3X"};